export const CODE_TABLE_OPTIONS = 'CODE_TABLE_OPTIONS'
export const CODE_TABLE_SET_OPTIONS = 'CODE_TABLE_SET_OPTIONS'